import { render, staticRenderFns } from "./dev-index.vue?vue&type=template&id=1c06f8a5&"
import script from "./dev-index.ts?vue&type=script&lang=ts&"
export * from "./dev-index.ts?vue&type=script&lang=ts&"
import style0 from "./dev-index.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports